import {Box, CardMedia} from "@mui/material";

function getYouTubeEmbedURL(url) {
  /* eslint-disable-next-line */
  const videoIdMatch = url?.match(/youtube\.com\/watch\?v=([^\&\?\/]+)/)
  return videoIdMatch ? `https://www.youtube.com/embed/${videoIdMatch[1]}` : null
}

function getVimeoEmbedURL(url) {
  const videoIdMatch = url?.match(/vimeo\.com\/([0-9]+)/)
  return videoIdMatch ? `https://player.vimeo.com/video/${videoIdMatch[1]}` : null
}

function getEmbedURL(url) {
  return getYouTubeEmbedURL(url) ?? getVimeoEmbedURL(url)
}

export type ProductSidebarVideoProps = {
  videoUrl: string
}

export function ProductSidebarVideo(props: ProductSidebarVideoProps) {
  const { videoUrl } = props;
  const embedUrl = getEmbedURL(videoUrl)
  return (<>
    {embedUrl &&
        <Box component='div'
             sx={(theme) => ({
               position: 'relative',
               paddingBottom: '56.25%',
               width: {
                 xs: '100%',
                 md: '40vw',
                 lg: '30vw',
                 xxl: '25vw',
               }
             })}
        >
          <CardMedia
              component='iframe'
              src={embedUrl}
              sx={(theme) => ({
                border: '0',
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              })}
          />
        </Box>
    }
  </>)
}
